import { useState, useEffect } from "react";
import { TiTimes } from "react-icons/ti";
import logo from "../../assets/images/logoMain.png";
import logoText from "../../assets/images/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Icon from "./Icon";
import { FaArrowLeft } from "react-icons/fa";
import { useToast } from "../contexts/ToastContext";
import { useAuth } from "../contexts/AuthContext";
import CartDropdown from "./CartDropdown";
import { useGeneral } from "../contexts/GeneralContext";
import { useCart } from "../contexts/CartContext";
import PlaneBadge from "./PlaneBadge";

export default function Header({ code }) {
  const { isLoggedIn } = useAuth();
  const { showCart, isCartVisible, hideCart, extraContent } = useGeneral();
  const { cart } = useCart();

  const navItems = [
    "Plans",
    "Meals",
    "Shop",
    "About",
    "Reviews",
    "Careers",
    "Contact",
  ];
  const navItemsMobile = [
    { label: "Plans", url: "plans" },
    { label: "Meals", url: "meals" },
    { label: "Shop", url: "shop" },
    { label: "About", url: "about" },
    { label: "Reviews", url: "reviews" },
    { label: "News & Events", url: "news-events" },
    { label: "Terms & Conditions", url: "terms" },
    { label: "Recipes", url: "recipes" },
    { label: "Careers", url: "careers" },
    { label: "Contact", url: "contact" },
    { label: "Schools/Nurseries", url: "school-nursery" },
    { label: "Party Catering", url: "party-catering" },
  ];

  const colors = ["bg-orange", "bg-primary", "bg-secondary", "bg-tertiary"]; // dynamic colors

  const [state, setState] = useState({
    active: "Home",
    currentState: "main",
    menuOpen: false,
    mobilePopup: false,
    scrolled: false,
    closePromo: false,
    showPopup: false,
    index: 0,
  });
  const { addToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  // Auto-flip every 5 seconds
  const handleClick = () => {
    if (isLoggedIn) {
      navigate("/account");
      if (isCartVisible) {
        hideCart();
      }
    } else {
      isCartVisible ? hideCart() : showCart();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setState((prev) => ({
        ...prev,
        index: (prev.index + 1) % code?.length,
      }));
    }, 5000);

    return () => clearInterval(interval);
  }, [code?.length]);
  async function universalCopy(text) {
    try {
      // 1. Try modern API (Chrome, Android, Desktop)
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {
      // continue to fallback
    }

    // 2. iOS & WebView fallback using temporary textarea
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.readOnly = true;

      textarea.style.position = "fixed";
      textarea.style.top = "-9999px";

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, text.length);

      const success = document.execCommand("copy");
      document.body.removeChild(textarea);

      return success;
    } catch (e) {
      // continue to deep fallback
    }

    // 3. Deep fallback for extremely restricted environments
    try {
      window.getSelection().removeAllRanges();
      const range = document.createRange();
      const el = document.createElement("span");
      el.textContent = text;
      document.body.appendChild(el);

      range.selectNode(el);
      window.getSelection().addRange(range);
      const success = document.execCommand("copy");

      window.getSelection().removeAllRanges();
      document.body.removeChild(el);

      return success;
    } catch (e) {
      return false;
    }
  }

  useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean); // remove empty strings

    if (pathSegments.length === 0) {
      setState((prev) => ({ ...prev, active: "Home" }));
    } else {
      // Take the first segment as the parent route
      setState((prev) => ({ ...prev, active: pathSegments[0] }));
    }
  }, [location.pathname]);

  // Handle scroll
  useEffect(() => {
    const isMobile = window.innerWidth <= 768; // you can adjust breakpoint

    const handleScroll = () => {
      setState((prev) => ({
        ...prev,
        scrolled: window.scrollY > (isMobile ? 100 : 50),
      }));
    };

    let timeoutId;

    const debouncedHandleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleScroll, 10); // debounce
    };

    window.addEventListener("scroll", debouncedHandleScroll);

    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    if (state.menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [state.menuOpen]);
  return (
    <div
      className={`w-full  mx-auto fixed left-0 top-0 right-0 z-[100] bg-[#fff] transition-all duration-300  px-2 sm:px-2 md:px-12 lg:px-14 xl:px-[85px] pb-2 md:pb-4 ${
        state.active === "Home" && state.scrolled
          ? "pt-2  xl:pt-24"
          : state.active != "Home" && state.scrolled
            ? " pt-2 sm:pt-18 md:pt-18 xl:pt-24"
            : state.active === "Home"
              ? " pt-20 sm:pt-18 md:pt-18 xl:pt-24"
              : state.active != "Home" && " pt-20 sm:pt-18 md:pt-18 xl:pt-24"
      }`}
    >
      <header
        className={`w-full relative mx-auto  p-0 rounded-[15px] bg-[#dfe3de]  flex items-center justify-center transition-all duration-300 ${
          state.active === "Home" && state.scrolled
            ? "min-h-[58px] xl:min-h-[58px] rounded-[25px]"
            : state.active != "Home" && state.scrolled
              ? "min-h-[58px] xl:min-h-[58px] rounded-[25px]"
              : state.active === "Home"
                ? "min-h-[86px] xl:min-h-[116px]"
                : state.active != "Home" &&
                  "min-h-[86px] xl:min-h-[58px] rounded-[25px]"
        }`}
      >
        {/* Promo Banner */}

        {!state.closePromo && code?.length > 0 && (
          <div
            className={`hidden max-w-[1085px] xl:flex absolute xl:-top-[90px] -top-16 z-[999] xl:min-h-[69px] lg:py-2 xl:min-w-[62%] lg:w-[55%] rounded-[20px] px-4 flex items-center justify-center transition-all duration-300 mt-2 overflow-hidden bg-orange`}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={state.index}
                initial={{ rotateY: 90, opacity: 0 }}
                animate={{ rotateY: 0, opacity: 1 }}
                exit={{ rotateY: -90, opacity: 0 }}
                transition={{ duration: 0.6 }}
                className="text-white  text-32pt lg:text-xl  xl:text-[20px] 2xl:text-[25px] 2.5xl:text-32pt  leading-tight text-center px-6"
              >
                {code[state.index]?.title}{" "}
                <span
                  title="Click to copy"
                  className="underline cursor-pointer text-32pt lg:text-xl  xl:text-[20px] 2xl:text-[25px] 2.5xl:text-32pt "
                  onClick={() => {
                    navigator.clipboard.writeText(
                      code[state.index]?.couponCode,
                    );
                    addToast(
                      "Coupon code copied! Paste it at checkout to save big.",
                      "success",
                    );
                  }}
                >
                  {code[state.index]?.couponCode}
                </span>
              </motion.div>
            </AnimatePresence>

            <TiTimes
              title="Click to close"
              onClick={() =>
                setState((prev) => ({ ...prev, closePromo: true }))
              }
              className="right-2 absolute text-3xl text-white cursor-pointer"
            />
          </div>
        )}

        {/* Desktop Navigation */}
        <nav className="flex-1 flex justify-center hidden xl:flex relative">
          {/* Logo */}
          <div
            className={`absolute cursor-pointer transition-all duration-300  xl:w-[150px] lg:w-[120px] xl:top-[-105px] lg:top-[-70px] top-[-105px]
    ${
      state.active === "Home" && state.scrolled
        ? "xl:w-[150px] lg:w-[120px] xl:top-[-105px] lg:top-[-70px] top-[-105px]"
        : state.active === "Home" &&
          "2.5xl:w-[206px]  xl:w-[190px] lg:w-[160px] 2.5xl:top-[-125px] xl:top-[-115px]  lg:top-[-85px] top-[-125px]"
    } 2.5xl:left-[5.8%] xl:left-[4%] lg:left-[3%] left-[5%]`}
            onClick={() => {
              setState((prev) => ({ ...prev, active: "Home" }));
              navigate("/");
            }}
          >
            <img
              src={logo}
              className="w-full h-auto"
              title="View home page"
              alt="Logo"
            />
          </div>

          {/* Menu Items */}
          <ul
            className={`flex items-center gap-2 md:gap-2 transition-all duration-300  ${
              state.scrolled && state.active === "Home"
                ? "lg:translate-x-10 1xl:translate-x-0"
                : "lg:translate-x-[60px] 1xl:translate-x-[40px]"
            }`}
          >
            <li
              title="View home page"
              className={`cursor-pointer  pe-4  `}
              onClick={() => {
                setState((prev) => ({ ...prev, active: "Home" }));
                navigate("/");
              }}
            >
              <Icon
                icon="home"
                className={`${
                  state.active === "Home"
                    ? "text-green"
                    : "text-gray-800 hover:text-green"
                } w-8 h-8 lg:w-[26px] lg:h-[26px]`}
              />

              {/* <img src={home} width={32} height={32} /> */}
            </li>
            {navItems.map((item, index) => (
              <li
                key={index}
                className={`1xl:text-21pt lg:text-18pt text-21pt cursor-pointer 2.5xl:px-8 1xl:px-4 lg:px-3 px-3 py-0 rounded-lg transition-all duration-500 ease-in-out ${
                  state.active.toLocaleLowerCase() === item.toLocaleLowerCase()
                    ? "bg-white text-green "
                    : "text-gray-800 hover:bg-[#fff]/60 hover:text-green-700"
                }`}
                onClick={() => {
                  setState((prev) => ({ ...prev, active: item }));
                  navigate(`/${item.toLowerCase()}`);
                }}
              >
                {item}
              </li>
            ))}
          </ul>
        </nav>

        {/* Desktop My Account */}
        <div
          className={`absolute right-10 hidden xl:flex items-center gap-2 
          transition-all duration-500 ease-in-out
          ${
            state.active === "account"
              ? "bg-orange text-white rounded-[10px] w-[165px] h-[40px] flex items-center justify-center"
              : "bg-transparent text-orange hover:text-green"
          }`}
          style={{ top: state.active === "account" ? "-50px" : "-40px" }}
          onClick={isCartVisible ? () => hideCart() : () => handleClick()}
        >
          <Icon icon="profile" size={24} className="" />
          <button className="text-18pt flex items-center gap-2">
            My Account
          </button>
        </div>

        {/* Popup when NOT logged in */}
        {isCartVisible && <CartDropdown />}

        {/* Mobile Hamburger */}
        {state.active != "Home" && (
          <div className="absolute top-1/2 -translate-y-1/2 left-4 xs:left-8 xl:hidden">
            <Icon
              icon="home"
              size={35}
              className={"text-green hover:text-secondary"}
              onClick={() => navigate("/")}
            />
          </div>
        )}
        <div className="absolute top-1/2 -translate-y-1/2 right-4 xs:right-8 xl:hidden">
          <Icon
            icon="menu"
            size={35}
            className={"text-green hover:text-secondary"}
            onClick={() => {
              if (isCartVisible) {
                hideCart();
              } else {
                setState((prev) => ({ ...prev, menuOpen: true }));
              }
            }}
          />
          {cart?.items?.length > 0 && <PlaneBadge />}
          {/* <HiOutlineMenu
            className="text-5xl text-green cursor-pointer"
            onClick={() => setState((prev) => ({ ...prev, menuOpen: true }))}
          /> */}
        </div>

        {/* Mobile Logo */}
        {!state.scrolled && code?.length > 0 && (
          <div
            onClick={() =>
              setState((prev) => ({
                ...prev,
                mobilePopup: true,
              }))
            }
            className="absolute transition-all duration-300 cursor-pointer xl:hidden w-[25px] right-6 xs:right-10"
            style={{ top: "-45px" }}
          >
            <Icon
              icon="bell"
              size={30}
              className={"text-orange hover:text-green"}
            />
            {/* <img src={bell} className="w-full h-auto border" alt="Logo" /> */}
          </div>
        )}
        {state.mobilePopup && code?.length > 0 && (
          <div
            className={`flex fixed top-0 z-[999] min-h-[209px] md:min-h-[150px] w-[95%] md:w-[90%]  rounded-[20px] px-4 flex items-center justify-center transition-all duration-300 mt-2 overflow-hidden bg-orange`}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={state.index}
                initial={{ rotateY: 90, opacity: 0 }}
                animate={{ rotateY: 0, opacity: 1 }}
                exit={{ rotateY: -90, opacity: 0 }}
                transition={{ duration: 0.6 }}
                className="text-white text-32pt text-center p-8"
              >
                {code[state.index]?.title}{" "}
                <span
                  title="Click to copy"
                  className="underline cursor-pointer text-32pt"
                  onClick={async () => {
                    const copied = await universalCopy(
                      code[state.index]?.couponCode,
                    );

                    if (copied) {
                      addToast(
                        "Coupon code copied! Paste it at checkout to save big.",
                        "success",
                      );
                    }
                  }}
                >
                  {code[state.index]?.couponCode}
                </span>
              </motion.div>
            </AnimatePresence>

            <TiTimes
              title="Click to close"
              onClick={() =>
                setState((prev) => ({ ...prev, mobilePopup: false }))
              }
              className="right-2 top-3 absolute text-3xl text-white cursor-pointer"
            />
          </div>
        )}
        <div
          className="absolute transition-all duration-300 cursor-pointer xl:hidden w-[169px] left-1/2 -translate-x-1/2"
          style={{ top: state.scrolled ? "20px" : "-80px" }}
          onClick={() => {
            setState((prev) => ({ ...prev, active: "Home" }));
            navigate("/");
          }}
        >
          <img
            src={state.scrolled ? logoText : logo}
            title="View home page"
            className="w-full h-auto"
            alt="Logo"
          />
        </div>

        {/* Mobile Fullscreen Menu */}
        {state.menuOpen && (
          <div
            className="fixed inset-0 bg-white/80 -mt-3 z-50 flex flex-col 
               items-center justify-start pt-20 transition-opacity 
               duration-300 ease-in-out animate-fadeIn"
          >
            <ul
              className="flex flex-col rounded-[15px] bg-[#dfe3de] w-[95%] p-6 
                 items-center gap-6 text-gray-800 text-2xl list-none 
                 transform transition-all duration-300 ease-in-out 
                 animate-slideDown overflow-y-auto max-h-screen"
            >
              <button
                className="absolute right-8 xxs:right-4 xxs:top-2 xs:right-8 xs:top-4 text-4xl text-green hover:text-green-700 transition-colors duration-200"
                onClick={() =>
                  setState((prev) => ({ ...prev, menuOpen: false }))
                }
              >
                <Icon
                  icon="close"
                  size={30}
                  className={"text-orange hover:text-green"}
                />
              </button>

              <li
                onClick={() => navigate("/")}
                className="flex text-secondary hover:text-green items-center gap-2  cursor-pointer"
              >
                <img
                  src={logoText}
                  alt="Nutricub Logo"
                  className="h-auto xl:w-[206px] xl:w-[126px] w-[206px] object-contain mt-7"
                  title="View home page"
                />
              </li>

              <li
                className="flex text-secondary hover:text-green items-center gap-2 bg-white rounded-[8px] px-4 py-2 cursor-pointer relative"
                onClick={() =>
                  setState((prev) => ({ ...prev, currentState: "account" }))
                }
              >
                {state.currentState !== "main" && (
                  <button
                    title="Click to view main menu"
                    className="absolute top-[10px] z-[150] -left-10 text-4xl text-green hover:text-green-700 transition-colors duration-200"
                    onClick={(e) => {
                      e.stopPropagation(); // prevent li click from firing
                      setState((prev) => ({ ...prev, currentState: "main" }));
                    }}
                  >
                    <FaArrowLeft size={25} className="text-green" />
                  </button>
                )}

                <Icon icon="profile" size={28} className={""} />

                <span
                  className="text-24pt transition-colors duration-200 flex items-center gap-2"
                  onClick={(e) => {
                    e.stopPropagation(); // prevent parent li click if needed

                    if (!isLoggedIn) {
                      setState((prev) => ({
                        ...prev,
                        currentState: "account",
                      }));
                    } else {
                      navigate("/account");
                    }
                  }}
                >
                  My Account
                </span>
                {cart?.items?.length > 0 && state.currentState === "main" && (
                  <PlaneBadge />
                )}
              </li>

              {state.currentState === "main" &&
                navItemsMobile.map((item, index) => (
                  <li
                    key={index}
                    className={`cursor-pointer hover:text-green text-24pt transition-colors duration-200 ${
                      state.active.toLocaleLowerCase() ===
                      item.url.toLocaleLowerCase()
                        ? "text-green "
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        active: item.label,
                        menuOpen: false,
                      }));
                      navigate(`/${item.url}`);
                    }}
                  >
                    {item.label}
                  </li>
                ))}
              {state.currentState === "account" && (
                <>
                  {/* <li
                    className={`cursor-pointer hover:text-green text-24pt transition-colors duration-200 text-secondary
                  `}
                  >
                    My Subscriptions
                  </li> */}
                  <li
                    className={`cursor-pointer hover:text-green text-24pt transition-colors duration-200  ${
                      state.active.toLocaleLowerCase() === "cart"
                        ? "text-green "
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      navigate("/cart");
                    }}
                  >
                    <span className="relative">
                      My Cart {cart?.items?.length > 0 && <PlaneBadge />}{" "}
                    </span>
                  </li>
                  <li
                    className={`cursor-pointer hover:text-green text-24pt transition-colors duration-200 ${
                      state.active.toLocaleLowerCase() === "signin"
                        ? "text-green "
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      navigate("/signin");
                    }}
                  >
                    Login
                  </li>
                  <li
                    className={`cursor-pointer hover:text-green text-24pt transition-colors duration-200 ${
                      state.active.toLocaleLowerCase() === "signup"
                        ? "text-green "
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >
                    Signup
                  </li>
                </>
              )}
              {extraContent?.whatsAppNumber && (
                <li
                  className="flex items-center gap-2 bg-quaternary rounded-[8px] px-4 py-2 cursor-pointer"
                  onClick={() =>
                    window.open(
                      `https://wa.me/${extraContent?.whatsAppNumber}?text=Hello`,
                      "_blank",
                    )
                  }
                >
                  <Icon
                    icon="comment"
                    size={28}
                    className={"text-secondary hover:text-green"}
                  />
                  <button className="text-secondary text-lg hover:text-green text-18pt transition-colors duration-200 flex items-center gap-2">
                    Chat
                  </button>
                </li>
              )}
            </ul>
          </div>
        )}
      </header>
    </div>
  );
}
